import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


import '../styles/about.scss'

export default function About(){
    return(
        <div className="about" id="about">
            <h1>About</h1>
            <div className="about-column">
                <div className="column">
                    <h3 className="about-title">Description</h3>
                    <h5 className="about-desc">
                        Context Explorer NYC helps designers, architects, and citizens become more acquainted with city data.
                        This demonstration project aims to visualize zoning and site information needed to jump-start preliminary design projects. 
                        Data comes from NYC Open Data and is not verified for accuracy or completeness.
                        Disclaimer: Please consult a planning and design professional for official planning and development guidance.
                    </h5>
                    <h4 className="disclaimer-desc"><b>DISCLAIMER:  
                    This is a demonstration project. 
                    
                    The data, information, and maps provided herein are derived from various publicly available data sources and are dynamic and in ongoing state of maintenance, correction 
                    and update, and are subject to verification by the user. The mapped data here depicted herein does not constitute a legal survey. 

                    This website makes no warranty, representation, or guarantee as to the content, accuracy, timeliness or completeness of any of the information implied herein.
                    This website explicity disclaims any representation and warranties, including, without limitation, the implied warranties of merchantability and fitness for any particular purpose.                    
                    </b>
                    </h4>
                    <h3 className="about-title">Authors</h3>
                    <ul>
                        <li>Edbert Cheng <a href="https://github.com/urbandesign09" rel="noreferrer noopener" target="_blank">/urbandesign09</a></li>
                        <li>Yiwen Che <a href="https://github.com/YiwenChe" rel="noreferrer noopener" target="_blank">/YiwenChe</a></li>
                    </ul>
                </div>
                <div className="column">
                    <h3 className="about-title">Sources</h3>
                    <h5 className="about-desc">
                        This project was built with <a href="https://reactjs.org/" rel="noreferrer noopener" target="_blank">React</a>, using <a href="https://create-react-app.dev/" rel="noreferrer noopener" target="_blank">create-react-app</a>, and hosted on <a href="https://netlify.com" rel="noreferrer noopener" target="_blank">Netlify</a>.
                        The map viewer employs the <a href="https://www.mapbox.com/mapbox-gljs" rel="noreferrer noopener" target="_blank">Mapbox GL JS</a> library. Zoning, lot, and building information is provided by <a href="https://opendata.cityofnewyork.us/" rel="noreferrer noopener" target="_blank">NYC Open Data</a> and <a href="https://www1.nyc.gov/site/planning/data-maps/open-data/dwn-pluto-mappluto.page" rel="noreferrer noopener" target="_blank">PLUTO</a>, via the <a href="https://developers.arcgis.com/rest/" rel="noreferrer noopener" target="_blank">ArcGIS REST API</a> library.
                        Icons are sourced from <a href="https://reactjs.org/" rel="noreferrer noopener" target="_blank">Font Awesome</a>. 
                        Project repository information is available on request.
                    </h5>
                    <h3 className="about-title">Open Data</h3>
                    <h5 className="about-desc">
                    NYC Open Data assets were utilized for the backend database. 
                    Starting with the zoning district geodata within the mapPLUTO dataset, our map renders layers of district types, public transportation, and neighborhoods based on the information. 
                    Users are able to turn on/off specific layers per their individual visualization needs.
                    Following this, each address search connects to the mapPLUTO API to look up specific lot and building information from the NYC Zoning Tax Lot Database.
                    <br/>
                    <br/>
                    <b>Open Data Asset Links</b>
                    <br/>
                    <a href="https://data.cityofnewyork.us/City-Government/NYC-Zoning-Tax-Lot-Database/fdkv-4t4z" rel="noreferrer noopener" target="_blank">NYC Zoning Tax Lot Database</a>
                    <br/>
                    <a href="https://www1.nyc.gov/site/planning/data-maps/open-data/dwn-pluto-mappluto.page" rel="noreferrer noopener" target="_blank">MapPLUTO</a>

                    </h5>


                </div>   
            </div>
           
            <br/>
            <div className="splash-icons">
                <FontAwesomeIcon icon={['fab', 'github']} className="icon-spacing"/>
                <FontAwesomeIcon icon={['fab', 'html5']} className="icon-spacing"/>
                <FontAwesomeIcon icon={['fab', 'js-square']} className="icon-spacing"/>
                <FontAwesomeIcon icon={['fab', 'sass']} className="icon-spacing"/>
                <FontAwesomeIcon icon={['fab', 'react']} className="icon-spacing"/>
            </div>
        
        </div>
    )
}